import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";

import useApi from "../../hooks/useApi";

import { weekDays } from "../../store/GlobalVarriables";
import RenderActivities from "../../Components/RenderActivities/RenderActivities";
import Loader from "../../Components/Loader";
import { ReactComponent as UserIcon } from "../../static/images/user_profile.svg";

import "./style.scss";

const ConsumerClasses = () => {
  const { get, loading } = useApi();

  const [ClassesData, setClassesData] = useState([]);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const fetchClasses = async () => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
    const decodedToken = jwtDecode(ps10005000);

    try {
      const data = await get(
        `/BusinessAccount/${decodedToken.buid}/Subscriptions?oneTime=true`,
      );

      setClassesData(data);
    } catch (err) {}
  };

  const convertDate = (value) => {
    const date = new Date(value);

    const day = date.getDate();
    const month = date.getMonth() + 1;

    const monthName = t(`months.${month}`);

    const formattedDate = `${day} ${monthName}`;

    return formattedDate;
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  return (
    <div className="classes-container">
      {loading && <Loader />}

      {ClassesData.length === 0 ? (
        <div className="empty-classes-container">
          <h1>{t("my_classes_empty_header")}</h1>
        </div>
      ) : (
        <>
          <ul>
            <h3>{t("my_classes_header")}</h3>

            {ClassesData.map((item) => {
              return (
                <li key={item.id}>
                  <div
                    className="classes-single-item"
                    onClick={() => {
                      navigate(`/my-classes/${item.scheduleId}`);
                    }}
                  >
                    <div className="classes-item-content">
                      <div className="classes-provider-name">
                        {item.providerProfileUrl ? (
                          <>
                            <img src={item.providerProfileUrl} alt="" />
                            <span>{item.providerName}</span>
                          </>
                        ) : (
                          <>
                            <UserIcon />
                            <span>{item.providerName}</span>
                          </>
                        )}
                      </div>
                      <div className="schedule-days">
                        {item.isOneTime ? (
                          <>
                            <span>
                              {convertDate(item.scheduleEffectiveFrom)}
                            </span>
                          </>
                        ) : (
                          <>
                            {item.scheduleDays
                              .sort(
                                (a, b) =>
                                  weekDays.indexOf(a.dayOfWeek) -
                                  weekDays.indexOf(b.dayOfWeek),
                              )
                              .map((day) => {
                                return (
                                  <React.Fragment key={day.id}>
                                    <span>
                                      {t(
                                        day.dayOfWeek.slice(0, 2).toLowerCase(),
                                      )}
                                    </span>
                                    <span className="schedule-days-comma">
                                      ,
                                    </span>
                                  </React.Fragment>
                                );
                              })}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="calss-activities">
                      <RenderActivities
                        activities={item.scheduleActivityName}
                      />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </>
      )}
    </div>
  );
};

export default ConsumerClasses;
